import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// --- Enhanced Global Error Handlers ---
window.addEventListener('error', function(event) {
    // Enhanced logging for LiveKit room context errors
    if (event.error?.message?.includes('No room provided')) {
        console.error('=== LIVEKIT ROOM CONTEXT ERROR DEBUG ===');
        console.error('Error message:', event.error.message);
        console.error('Filename:', event.filename);
        console.error('Line:', event.lineno, 'Column:', event.colno);
        console.error('Full stack trace:', event.error.stack);
        
        // Try to extract React component info from stack
        const stack = event.error.stack;
        if (stack) {
            const lines = stack.split('\n');
            console.error('Stack lines:', lines);
            
            // Look for component names in stack
            const componentLine = lines.find(line => 
                line.includes('at ') && (
                    line.includes('LiveSessionMain') ||
                    line.includes('VideoConference') ||
                    line.includes('useRoom') ||
                    line.includes('useParticipant')
                )
            );
            if (componentLine) {
                console.error('Likely component causing error:', componentLine);
            }
        }
        
        console.error('Current location:', window.location.href);
        console.error('React version:', React.version);
        console.error('==========================================');
        
        // More specific alert for LiveKit errors
        alert(`LiveKit Room Context Error!\n\nThis means a LiveKit component is being used outside of a <LiveKitRoom> wrapper.\n\nCheck the console for detailed stack trace.\n\nError: ${event.error.message}`);
    } else {
        // Standard error logging
        console.error('GLOBAL UNCAUGHT ERROR:', {
            message: event.message,
            filename: event.filename,
            lineno: event.lineno,
            colno: event.colno,
            error: event.error
        });
        alert('A global JavaScript error occurred. Check the browser console for "GLOBAL UNCAUGHT ERROR". Error: ' + event.message);
    }
});

window.addEventListener('unhandledrejection', function(event) {
    console.error('GLOBAL UNHANDLED PROMISE REJECTION:', event.reason);
    
    // Check if it's a LiveKit related promise rejection
    if (event.reason?.message?.includes('room') || event.reason?.message?.includes('LiveKit')) {
        console.error('=== LIVEKIT PROMISE REJECTION ===');
        console.error('Reason:', event.reason);
        console.error('Stack:', event.reason?.stack);
        console.error('=================================');
    }
    
    alert('An unhandled promise rejection occurred. Check the browser console for "GLOBAL UNHANDLED PROMISE REJECTION". Reason: ' + (event.reason?.message || event.reason));
});

// Add React Error Boundary debugging
const originalError = console.error;
console.error = function(...args) {
    // Intercept React error boundary errors
    if (args[0]?.includes?.('React') || args[0]?.includes?.('component')) {
        console.log('=== REACT ERROR INTERCEPTED ===');
        console.log('Args:', args);
        console.log('===============================');
    }
    
    // Check for LiveKit related errors
    if (args.some(arg => 
        typeof arg === 'string' && (
            arg.includes('room') || 
            arg.includes('LiveKit') || 
            arg.includes('No room provided')
        )
    )) {
        console.log('=== LIVEKIT RELATED CONSOLE ERROR ===');
        console.log('Args:', args);
        console.log('===================================');
    }
    
    originalError.apply(console, args);
};

// Debug LiveKit imports
window.addEventListener('DOMContentLoaded', () => {
    console.log('=== DEBUGGING INFO ===');
    console.log('Current URL:', window.location.href);
    console.log('React version:', React.version);
    
    // Check if LiveKit is loaded
    setTimeout(() => {
        if (window.LiveKitRoom) {
            console.log('LiveKit components detected in window');
        }
        
        // Check for any global LiveKit errors
        if (window.__LIVEKIT_ERRORS__) {
            console.error('Global LiveKit errors:', window.__LIVEKIT_ERRORS__);
        }
    }, 1000);
});

// --- End of Enhanced Global Error Handlers ---

ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);